import React, {Component} from "react";
import {GoogleLogo} from "../../logos/GoogleLogo";
import {FacebookLogo} from "../../logos/FacebookLogo";
import {FaIcon} from "../../FaIcon";
import {SheetLogo} from "../../logos/SheetLogo";
import {Switch} from "../../buttons/Swtich";
import {TiktokLogo} from "../../logos/TiktokLogo";
import {LinkedinLogo} from "../../logos/LinkedinLogo";
import {ShopifyLogo} from "../../logos/ShopifyLogo";
import {TiendaNubeLogo} from "../../logos/TiendaNubeLogo";
import {WooCommerceLogo} from "../../logos/WooCommerceLogo";
import {VtexLogo} from "../../logos/VtexLogo";
import {AnalyticsLogo} from "../../logos/AnalyticsLogo";
import {SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, WOOCOMMERCE_CHANNEL, VTEX_CHANNEL, ANALYTICS_CHANNEL, CHANNEL_INFO_BY_CHANNEL, CHANNEL_TYPE_PAID_MEDIA} from "../../channels/channels";

export class BusinessUnitAdAccountNameCell extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showOnlyActive: true,
            showFilter: this.props.showFilter
        };

        this.handleOnlyActiveChange = this.handleOnlyActiveChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.showFilter !== prevProps.showFilter) {
            this.setState({showFilter:this.props.showFilter});
        }
    }

    _getChannelClassName() {
        return ("bu-cell ad_account_row")
    }

    _renderTooltipIfNecessary() {
        if (this._hasAlert()) {
            return <div className="bu-tooltip">
                <FaIcon iconName="exclamation-triangle"/>
                <p className="tooltip-description">
                    {this._alertMessage()}
                </p>
            </div>;
        }
    }

    _alertMessage() {
        if(this.props.generalAlerts.has_no_access_alert)
            return this.props.generalAlerts.has_no_access_alert
        if(this._isPaidMediaChannel() && this.props.generalAlerts.has_no_impression_alert)
            return 'La cuenta no tiene impresiones'
        return ''
    }

    render() {
        return (
            <td>
                <div className={this._getChannelClassName()}>
                    <div className="bu-name-with-tooltip">
                        <div className="bucc-name">
                            {this._ad_account_detailed_name()}
                        </div>
                        {this._renderTooltipIfNecessary()}
                    </div>
                    <div className="some-icons">
                        {this.renderAllCampaignsFilter()}
                        {this.renderOnlyWith30dImpressionsLabel()}
                        {/*{this.renderToggleDetails()}*/}
                    </div>
                </div>
            </td>
        );
    }

    renderOnlyWith30dImpressionsLabel() {
        if(!this.props.showOnlyActiveLabel)
            return

        return <span className="ml-2 mr-2  only_active">Campañas con Imp en 30d</span>;
    }

    renderAllCampaignsFilter() {
        if(!this.state.showFilter)
            return null;

        return <div className="status-toggl" style={{fontSize:"0.85em"}}>
            <Switch key={this.props.buccId} onChange={this.handleOnlyActiveChange} checked={this.state.showOnlyActive}/>
            <span className="status-label">Sólo activas</span>
        </div>;
    }

    handleOnlyActiveChange(event) {
        const showOnlyActive = event.target.checked;

        this.setState({
            showOnlyActive: showOnlyActive
        });

        this.props.onOnlyActiveCampaignsChange(this.props.buccId, showOnlyActive);
    }

    // renderToggleDetails() {
    //     return <BusinessUnitShowAdAccountsOrCampaignsTooltip key="bu-show-ad-accounts-icon"
    //                                                          message={null}
    //                                                          onClick={this.props.onCampaignsDataToggle}
    //                                                          enabled={true}
    //                                                          isShowing={this.props.campaignsRowsExpanded}
    //     />
    // }

    _isPaidMediaChannel() {
        return CHANNEL_INFO_BY_CHANNEL[this.props.channel]?.channelType === CHANNEL_TYPE_PAID_MEDIA;
    }

    _hasAlert() {
        if (this.props.generalAlerts === null) return false;
        if (this.props.generalAlerts.has_no_access_alert) return true;
        return this._isPaidMediaChannel() && this.props.generalAlerts.has_no_impression_alert;
    }

    // helpers

    _ad_account_detailed_name() {
        const platformLogo = this._getPlatformLogo();
        const nameWithAlert = this._getNameWithAlert();

        return [platformLogo, nameWithAlert]
    }

    _getNameWithAlert() {
        const classIfAlert = this._hasAlert() ? "bu-ad-account-name-with-alert" : "";

        return <span className={classIfAlert} style={{verticalAlign: "middle", paddingLeft:".3em"}}>{this.props.accountName} [{this.props.accountId}]</span>
    }

    _getPlatformLogo() {
        let platformLogo = null;
        const style = {
            verticalAlign: 'middle',
            margin: '0'
        };

        if (this.props.channel === 'GOOGLE') {
            platformLogo = <GoogleLogo height={"13"} width={"13"} styles={style} />
        } else if (this.props.channel === 'FACEBOOK') {
            platformLogo = <FacebookLogo height={"16"} width={"16"} styles={style}/>
        } else if (this.props.channel === 'SHEET') {
            platformLogo = <SheetLogo height={"16"} width={"16"} styles={style}/>
        } else if (this.props.channel === 'TIKTOK') {
            platformLogo = <TiktokLogo height={"16"} width={"16"} styles={style}/>
        } else if (this.props.channel === 'LINKEDIN') {
            platformLogo = <LinkedinLogo height={"16"} width={"16"} styles={style}/>
        } else if (this.props.channel === SHOPIFY_CHANNEL) {
            platformLogo = <ShopifyLogo height={"16"} width={"16"} styles={style}/>
        } else if (this.props.channel === TIENDA_NUBE_CHANNEL) {
            platformLogo = <TiendaNubeLogo height={"16"} width={"16"} styles={style}/>
        } else if (this.props.channel === WOOCOMMERCE_CHANNEL) {
            platformLogo = <WooCommerceLogo height={"16"} width={"16"} styles={style}/>
        } else if (this.props.channel === VTEX_CHANNEL) {
            platformLogo = <VtexLogo height={"16"} width={"16"} styles={style}/>
        } else if (this.props.channel === ANALYTICS_CHANNEL) {
            platformLogo = <AnalyticsLogo height={"14"} width={"14"} styles={style}/>
        }
        return platformLogo;
    }
}
